import React from 'react';
import FieldBold from '../../Fields/FieldBold/FieldBold';

import classes from './InfoGeneral.module.scss';
import { documentTypesAbbreviationsObject } from '../../../store/catalogs/documentTypes';

const InfoGeneral = ({ collaborator, className }) => {
  const classesContent = [classes.content];

  className && classesContent.push(className);

  const {
    receiverName,
    receiverLastName,
    metadata: { positionLabel },
    receiverIdentificationType,
    receiverIdentificationNumber
  } = collaborator;

  return (
    <div className={classesContent.join(' ')}>
      <span className='semibold-18'>Información general</span>
      <div className={classes['first-field']}>
        <FieldBold title='COLABORADOR' value={`${receiverName} ${receiverLastName}`} />
        <FieldBold title='CARGO' value={positionLabel} />
        <div className={classes['second-fields']}>
          <FieldBold
            title='IDENTIFICACIÓN'
            value={`${documentTypesAbbreviationsObject[receiverIdentificationType]} ${receiverIdentificationNumber}`}
          />
          {/* <FieldBold title='TIPO DE CONTRATO' value={contractType} /> */}
        </div>
      </div>
    </div>
  );
};

export default InfoGeneral;
